import { SpecialGiftList } from 'components/general-settings/special-gift-list/SpecialGiftList'
import { useLocation, useSearchParams } from 'react-router-dom'
import { getAllQueryParams, setQueryParams } from 'utils/utils'
import { INITIAL_DATA_FILTER } from 'configs/general-settings/configTableSpecialGiftList'
import { useEffect, useState } from 'react'
import { useFetch } from 'services/useFetch'
import { API_SPECIAL_GIFT } from 'services/apiSpecialGift'
import { Alert } from 'avo-ui'

export const SpecialGiftListContainer = () => {
    const location = useLocation()
    const [searchParams, setSearchParams] = useSearchParams()
    const query = searchParams.size > 0 ? getAllQueryParams(searchParams) : INITIAL_DATA_FILTER
    const [showModalDelete, setShowModalDelete] = useState(false)
    const [deleteId, setDeleteId] = useState(null)
    const { fetching: getSpecialGiftList, data: specialGiftList, isLoading } = useFetch(API_SPECIAL_GIFT.LIST)
    const { fetching: deleteSpecialGift, isLoading: isDeleting } = useFetch(API_SPECIAL_GIFT.DELETE)

    useEffect(() => {
        fetchSpecialGiftList()
    }, [location?.search])

    const onShowModalDelete = (id) => {
        setDeleteId(id)
        setShowModalDelete(true)
    }

    const onHideModalDelete = () => {
        setShowModalDelete(false)
    }

    const onChangeQuery = (queryParams) => {
        const params = setQueryParams({ ...query, ...queryParams })
        setSearchParams(params, { replace: true })
    }

    const fetchSpecialGiftList = (item = { ...query }) => {
        getSpecialGiftList(item)
    }

    const onDelete = () => {
        deleteSpecialGift({}, deleteId).then(() => {
            if (specialGiftList?.data?.results?.length === 1 && Number(query?.page) !== 1) {
                onChangeQuery({ page: 1 })
            } else {
                fetchSpecialGiftList()
            }

            setShowModalDelete(false)
            return Alert({
                icon: 'success',
                title: 'Success',
                message: 'Special Gift Deleted !',
            })
        })
    }

    const props = {
        dataList: specialGiftList?.data,
        query,
        onChangeQuery,
        onDelete,
        showModalDelete,
        onShowModalDelete,
        onHideModalDelete,
        isDeleting,
        isLoading,
    }

    return <SpecialGiftList {...props} />
}
